import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CheckBox} from './components/checkbox.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {TextInputClassicComponent} from './components/text-input-classic.component';
import {ToggleComponent} from './components/toggle.component';

@NgModule({
	declarations: [
		TextInputClassicComponent,
		CheckBox,
        ToggleComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule
	],
	exports: [
		TextInputClassicComponent,
		CheckBox,
        ToggleComponent
	],
	providers: [
	]
})
export class CustomFormsModule {
}
